{
  "auth": {
    "language": "Til",
    "powered_by": "Powered by"
  },
  "calendar": {
    "choose_date": "Sanani tanlang",
    "choose_month": "Oyni tanlash",
    "choose_range": "Davrni tanlang",
    "choose_year": "Yilni tanlash",
    "clear": "Tozalash",
    "max_days": "ko'pi bilan {{count}} kun",
    "next_month": "Keyingi oy",
    "next_year": "Keyingi yil",
    "next_years": "Keyingi yillar",
    "pick_end": "Tugash kunini tanlang",
    "pick_start": "Boshlanish kunini tanlang",
    "previous_month": "Oldingi oy",
    "previous_year": "Oldingi yil",
    "previous_years": "Oldingi yillar",
    "today": "Bugun"
  },
  "change": {
    "down": "Tushish",
    "flat": "O'zgarishsiz",
    "unknown": "Solishtirib bo'lmaydi",
    "up": "O'sish"
  },
  "chart": {
    "download": "Yuklab olish",
    "download_excel": "Excel (joriy filtrlar bilan)",
    "download_png": "Rasm (PNG)",
    "fullscreen": "To'liq ekran",
    "table_view": "Jadval ko'rinishi"
  },
  "close": "Yopish",
  "color_picker": {
    "choose": "{{color}} rangini tanlash",
    "contrast_dark": "To'q matn: {{ratio}}:1",
    "contrast_fail": "O'qilishi qiyin",
    "contrast_pass": "O'qilishi yaxshi (WCAG AA)",
    "contrast_white": "Oq matn: {{ratio}}:1",
    "hex": "Rang kodi",
    "invalid": "#RRGGBB ko'rinishida kiriting, masalan #1F6FD4",
    "palette": "Tayyor ranglar",
    "swatch": "Rang tanlash"
  },
  "confirm": {
    "cancel": "Bekor qilish",
    "pending": "Bajarilmoqda…",
    "type_name": "Tasdiqlash uchun \"{{name}}\" deb yozing"
  },
  "date_names": {
    "months_long": "yanvar,fevral,mart,aprel,may,iyun,iyul,avgust,sentabr,oktabr,noyabr,dekabr",
    "months_of_day": "yanvar,fevral,mart,aprel,may,iyun,iyul,avgust,sentabr,oktabr,noyabr,dekabr",
    "months_short": "yan,fev,mar,apr,may,iyn,iyl,avg,sen,okt,noy,dek",
    "weekdays_long": "dushanba,seshanba,chorshanba,payshanba,juma,shanba,yakshanba",
    "weekdays_short": "Du,Se,Ch,Pa,Ju,Sh,Ya",
    "long_date_pattern": "{{day}} {{month}} {{year}}, {{weekday}}"
  },
  "dropzone": {
    "choose": "Fayl tanlash",
    "drop_now": "Qo'yib yuboring",
    "empty": "Hali rasm yo'q",
    "prompt": "Faylni shu yerga tashlang yoki tanlang"
  },
  "image_crop": {
    "cancel": "Bekor qilish",
    "description": "Rasmni suring, g'ildirak, ikki barmoq yoki slayder bilan kattalashtiring.",
    "load_failed": "Rasmni ochib bo'lmadi. Boshqa PNG yoki JPG faylni tanlang.",
    "loading": "Rasm ochilmoqda…",
    "render_failed": "Rasmni tayyorlab bo'lmadi. Qayta urinib ko'ring.",
    "save": "Saqlash",
    "shape": "Shakl",
    "shape_circle": "Aylana",
    "shape_square": "Kvadrat",
    "stage_label": "Kesish maydoni: strelkalar bilan suring, + va − bilan kattalashtiring",
    "title": "Rasmni kesish",
    "zoom": "Kattalashtirish",
    "zoom_in": "Kattalashtirish",
    "zoom_out": "Kichiklashtirish"
  },
  "image_slot": {
    "optional": "Ixtiyoriy",
    "remove": "O'chirish",
    "replace": "Almashtirish",
    "required": "Majburiy"
  },
  "language_name": {
    "en": "English",
    "ru": "Русский",
    "uz": "O'zbekcha"
  },
  "page": {
    "breadcrumb": "Sahifa yo'li"
  },
  "password": {
    "hide": "Parolni yashirish",
    "show": "Parolni ko'rsatish"
  },
  "period": {
    "apply": "Qo'llash",
    "cancel": "Bekor qilish",
    "choose": "Davrni tanlash",
    "compare_data_from": "{{range}} (ma'lumot {{date}} dan)",
    "compare_label": "Solishtirish",
    "compare_menu": "Nima bilan solishtirish",
    "compare_no_data": "ma'lumot yo'q",
    "compare_option": {
      "none": "Solishtirmaslik",
      "previous_day": "Kechagi kun",
      "previous_days": "Oldingi {{count}} kun",
      "previous_month": "O'tgan oy",
      "previous_months": "Oldingi {{count}} oy",
      "previous_week": "Oldingi hafta",
      "previous_year": "O'tgan yil",
      "same_day_last_year": "O'tgan yilning shu kuni",
      "same_period_last_month": "O'tgan oyning shu davri",
      "same_period_last_week": "O'tgan haftaning shu davri",
      "same_weekday": "O'tgan haftaning shu kuni",
      "year_over_year": "O'tgan yilning shu davri"
    },
    "date_placeholder": "kk.oo.yyyy",
    "day_count": "{{count}} kun",
    "from": "Boshlanish",
    "input_end_before_start": "Tugash sanasi boshlanishdan oldin",
    "input_future": "Kelajakdagi sanani tanlab bo'lmaydi",
    "input_invalid": "Bunday sana yo'q",
    "next": "Keyingi davr",
    "preset_custom": "Erkin davr",
    "preset_last_30_days": "Oxirgi 30 kun",
    "preset_last_7_days": "Oxirgi 7 kun",
    "preset_last_month": "O'tgan oy",
    "preset_this_month": "Bu oy",
    "preset_this_year": "Bu yil",
    "preset_today": "Bugun",
    "preset_yesterday": "Kecha",
    "previous": "Oldingi davr",
    "quick_ranges": "Tezkor davrlar",
    "to": "Tugash"
  },
  "progress": {
    "cancel": "Bekor qilish",
    "remaining": "Qoldi: {{time}}"
  },
  "rank": {
    "down": "{{count}} o'rin pastga",
    "medal": "{{rank}}-o'rin medali",
    "no_previous": "O'tgan davrda reytingda yo'q edi (ma'lumot yo'q)",
    "same": "O'rin o'zgarmadi",
    "up": "{{count}} o'rin yuqoriga"
  },
  "select": {
    "clear": "Tozalash",
    "count_of_max": "{{count}} / {{max}} tanlandi",
    "count_selected": "{{count}} ta tanlandi",
    "no_matches": "Hech narsa topilmadi",
    "search": "Qidirish",
    "toggle_group": "hammasi"
  },
  "shell": {
    "collapse_sidebar": "Menyuni yig'ish",
    "expand_sidebar": "Menyuni kengaytirish",
    "main_navigation": "Asosiy menyu",
    "more": "Yana",
    "powered_by": "Powered by {{platform}}",
    "skip_to_content": "Asosiy tarkibga o'tish"
  },
  "shortcuts": {
    "global": "Hamma joyda",
    "help": "Qisqa tugmalar ro'yxati",
    "search": "Qidirish",
    "title": "Klaviatura tugmalari"
  },
  "state": {
    "empty_title": "Ma'lumot yo'q",
    "error_description": "Tarmoq yoki server bilan bog'liq muammo. Qayta urinib ko'ring.",
    "error_title": "Ma'lumotni yuklab bo'lmadi",
    "loading": "Yuklanmoqda…",
    "outages": "Uzilishlar:",
    "partial": "To'liq emas",
    "partial_coverage": "Ma'lumot to'liqligi: {{percent}}%",
    "retry": "Qayta urinish",
    "stale": "Server oflayn — ma'lumot oxirgi marta {{time}} da olingan"
  },
  "table": {
    "columns": "Ustunlar",
    "csv": "CSV",
    "filter_placeholder": "Qidirish…",
    "more_rows": "Yana {{count}} ta qator: qidiruv bilan toraytiring"
  },
  "tag_input": {
    "remove": "{{value}} ni olib tashlash"
  },
  "theme": {
    "dark": "Qorong'i",
    "light": "Yorug'",
    "system": "Tizim bo'yicha",
    "toggle": "Mavzu"
  },
  "totp": {
    "code_label": "Ilovadagi 6 xonali kod",
    "confirm": "Tasdiqlash va yoqish",
    "digit_label": "{{number}}-raqam",
    "hide_key": "Kalitni yashirish",
    "manual_key": "Ilovaga qo'lda kiriting:",
    "qr_label": "Autentifikator ilovasi uchun QR kod",
    "show_key": "Kalitni ko'rsatish",
    "step_code": "Ilovadagi 6 xonali kodni pastga kiriting",
    "step_code_title": "Kodni kiriting",
    "step_install": "Google yoki Microsoft Authenticator (bepul)",
    "step_install_title": "Telefoningizga ilova o'rnating",
    "step_scan": "Ilovada «+» ni bosing va QR kodni skanerlang",
    "step_scan_title": "QR kodni skanerlang"
  }
}
